'use client';

import { notFound, useParams, useSearchParams } from 'next/navigation';
import { Heading } from 'ui';
import { Breadcrumbs } from '~/components/Breadcrumbs';
import { Divider } from '~/components/Divider';
import TravelInformationText from '~/components/TravelInformation/TravelInformationText';
import { useJourneyGuide } from '~/contexts/JourneyGuideContext';

export default function TravelInformationPage() {
  const params = useParams<{ slug: string; tripId: string }>();
  const searchParams = useSearchParams();
  const summary = searchParams?.get('summary');
  const tripId = params?.tripId;
  const slug = params?.slug;

  const [journeyGuide] = useJourneyGuide();

  // Check both the trip-specific travel information and the generic travel information
  const travelInfo = [...(journeyGuide.itinerary?.travelInformation ?? []), ...journeyGuide.allTravelInformations].find(
    (info) => info.slug === slug
  );

  if (!travelInfo) {
    return notFound();
  }

  return (
    <>
      <div className="px-4 pt-4 bg-primary-100">
        <Breadcrumbs
          items={[
            {
              href: `/journey-guide/${tripId}${summary ? '?summary=true' : ''}#${slug}`,
              label: 'Journey Guide'
            },
            {
              label: travelInfo.title || '',
              isCurrent: true,
              href: '#'
            }
          ]}
        />
      </div>
      <Divider variant="horizontal" />
      <div className="pt-16px px-16px pb-48px space-y-36px">
        <Heading as="h1" variant="h5">
          <span className="font-serif">{travelInfo.title}</span>
        </Heading>
        <TravelInformationText data={travelInfo.detail} />
      </div>
    </>
  );
}
